/** @jsxImportSource react */
import EntityTile from '@react/card';
import Carousel from '@react/shared/components/Carousel';
import { SearchResourceNew } from '@sly/core/types';

interface SectionProps {
  title: string;
  description: string;
  communities: SearchResourceNew[];
  graphic?: JSX.Element;
  belowDescription?: JSX.Element;
}

const CuratedSection = ({
  title,
  description,
  communities,
  graphic,
  belowDescription,
}: SectionProps) => {
  return (
    <div>
      <h2 className='font-t-l mb-4'>{title}</h2>

      <div className='mb-6 grid gap-4 rounded-lg border border-slate-lighter-90 p-4 md:grid-cols-2 md:gap-12 md:p-6'>
        <div>
          <div dangerouslySetInnerHTML={{ __html: description }} />
          {belowDescription}
        </div>
        {graphic}
      </div>
      {communities?.length !== 0 && (
        <Carousel
          className='py-4 !py-0'
          itemsQty={communities?.length}
          key='Favorites'
        >
          {communities?.map((community: SearchResourceNew) => (
            <EntityTile
              key={community.id}
              entity={community}
              eventProps={{
                location: 'curatedSearch',
              }}
              hideDescription
              intent='vertical'
            />
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default CuratedSection;
